export type ProjectClientLocation = {
  endClients?: string[] | null
  client?: string | null
  location?: string | null
}

export type PipeSetDimensions = {
  nominalOd: string | number
  nominalOdUnit: string
  wallThickness: string | number
  wallThicknessUnit: string
}

/** Join non-empty trimmed strings; returns null when nothing to show. */
export function joinMetaParts(
  parts: (string | null | undefined)[],
  sep = ' • '
): string | null {
  const trimmed = parts
    .map((part) => (typeof part === 'string' ? part.trim() : ''))
    .filter(Boolean)
  return trimmed.length > 0 ? trimmed.join(sep) : null
}

/** Client + location line for page headers; omits empty parts and stray separators. */
export function formatClientLocationSubtitle(project: ProjectClientLocation): string | null {
  return joinMetaParts([project.endClients?.[0] ?? project.client, project.location])
}

export function formatPipeSetDimensions(pipeSet: PipeSetDimensions): string {
  return `${pipeSet.nominalOd} ${pipeSet.nominalOdUnit} × ${pipeSet.wallThickness} ${pipeSet.wallThicknessUnit}`
}

export function formatProjectPageSubtitle(opts: {
  project: ProjectClientLocation
  pipeSet?: PipeSetDimensions | null
  wpsNumber?: string | null
  extraParts?: (string | null | undefined)[]
}): string | null {
  return joinMetaParts([
    formatClientLocationSubtitle(opts.project),
    opts.pipeSet ? formatPipeSetDimensions(opts.pipeSet) : null,
    opts.wpsNumber,
    ...(opts.extraParts ?? [])
  ])
}
